// Func = limiting Scope for this file
var lastScrollTop = 0;

(function(){
	//full navigation
    const fullnav = document.querySelector('.header__full-navigation'); 
	const outsideNavExit = document.querySelector('.content');
	const footerNavExit = document.querySelector('.footer');  
    const primaryNav = {
        navOpen: document.querySelector('.nav-btn-js'),
        navClose: document.querySelector('.close-btn-js')
    };

    if(fullnav) {
        primaryNav.navOpen.addEventListener('click', function () {
            fullnav.classList.add('expanded');
        });
        primaryNav.navClose.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
        });
		if($('.content').length > 0) {
			outsideNavExit.addEventListener('click', function () {
				fullnav.classList.remove('expanded');
			});
		}
		footerNavExit.addEventListener('click', function () {
            fullnav.classList.remove('expanded');
        });
    }

	//booking widget
	const fullbooking = document.querySelector('.booking-holder'); 
	const primaryBooking = { 
        bookOpen: document.querySelector('.book-btn-js'),
        bookClose: document.querySelector('.book-close-btn-js')
    };
	if(fullbooking) {
        primaryBooking.bookOpen.addEventListener('click', function () {
            fullbooking.classList.add('expanded');
        });
        primaryBooking.bookClose.addEventListener('click', function () {
            fullbooking.classList.remove('expanded');
        });
		if($('.content').length > 0) {
			outsideNavExit.addEventListener('click', function () {
				fullbooking.classList.remove('expanded');
			});
		}
		footerNavExit.addEventListener('click', function () {
            fullbooking.classList.remove('expanded');
        });
    }

	//header scroll
	let scrollpos = window.scrollY
	const full_header = document.querySelector('.header');

	window.addEventListener('scroll', function() { 
		scrollpos = window.scrollY;

		if (scrollpos >= 80) { 
			full_header.classList.remove("up"),
			full_header.classList.add("down")
		}
		else { 
			full_header.classList.remove("down"),
			full_header.classList.add("up")
		}
		//console.log(scrollpos)
	});

	$(document).ready(function () {

		// HOME MAP
		document.querySelectorAll('.locationMod').forEach(mod => {
			mod.querySelectorAll('[data-ref*="item"]').forEach(btn => {
				btn.addEventListener('click', () => {
					mod.querySelectorAll('[data-ref*="item"]').forEach(bt => bt.classList.remove('active') );
					mod.querySelectorAll(`[data-ref="${btn.dataset.ref}"]`).forEach(item => item.classList.add('active') );
				});
			});

			// MAP INTRO
			mod.querySelectorAll('[data-ref="item-intro"]').forEach(btn => {
				btn.addEventListener('mouseenter', () => {
					mod.querySelectorAll('[data-ref*="item"]').forEach(bt => bt.classList.remove('active') );
					mod.querySelectorAll(`[data-ref="item-intro"]`).forEach(item => item.classList.add('active') );
				});
			});
		});

		/* //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		}); */

	});

	setTimeout( () => {
		$( "[name='desired_date']" ).datepicker('option', 'maxDate', '+30');
	}, 100 )
}());
